import { ScreenName } from '@helpcenter/constants';
import type { RouteResource } from 'react-resource-router';
import { Login as LoginAsync } from 'view/login';
import SyncLogin from 'view/login/hocs';
import { fg } from '@atlaskit/platform-feature-flags';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';
import { anonymousScreenLayout, PORTAL_ROUTE_PREFIX, LOGIN_ROUTE } from '../common/constants';

const resources: RouteResource[] = [];
const Login = fg('jsm_portal_login_async_to_sync_component') ? SyncLogin : LoginAsync;

const portalLogin = {
    resources,
    name: 'portal-login',
    path: `${PORTAL_ROUTE_PREFIX}/user/login`,
    exact: true,
    component: Login,
};

const login = {
    resources,
    name: 'login',
    path: LOGIN_ROUTE,
    exact: true,
    component: Login,
};

const screenName = ScreenName.LOGIN;

const layoutProps = anonymousScreenLayout;

export const loginRoute = createRouteWithLayout(login, screenName, layoutProps);
export const portalLoginRoute = createRouteWithLayout(portalLogin, screenName, layoutProps);
